import clsx from "clsx";
import Link, { LinkProps } from "next/link";
import React from "react";
import { Margins, marginsClass } from "../Layout";
import css from "./page.module.scss";

export const enum PageLinkVariant
{
    Link,
    YellowLink,
    Button,
    NewButton,
    RoundedBorderButton,
}

type NextLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & LinkProps & { children?: React.ReactNode } & React.RefAttributes<HTMLAnchorElement>;

export interface PageLinkProps extends NextLinkProps
{
    margins?: Margins;
    variant?: PageLinkVariant;
}

export const PageLink = ({ className, margins, variant = PageLinkVariant.Link, ...props }: PageLinkProps): React.FunctionComponentElement<PageLinkProps> =>
{
    const classes = clsx(
        css["link"],
        marginsClass(margins),
        {
            [css["link--button"]]: variant === PageLinkVariant.Button,
            [css["link--link"]]: variant === PageLinkVariant.Link,
            [css["link--yellow-link"]]: variant === PageLinkVariant.YellowLink,
            [css["link--new-button"]]: variant === PageLinkVariant.NewButton,
            [css["link--rounded-border-button"]]: variant === PageLinkVariant.RoundedBorderButton,
        },
        className
    );

    return <Link {...props} className={classes} />;
}
